import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { encryptData, setToStorage } from "../assets";
import logo from "../assets/images/logo2.png";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { AppContext } from "../context/AppContext";
import { makeGetAPICall, makePostAPICall } from "../helpers/ApiHelpers";
import Loader from "../components/Loader";
import Swal from "sweetalert2";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import useWhitelabel from "../hooks/useWhitelabel";

function LoginWithCode() {
	const { setToken, setUser, setSchool, token, user } = useContext(AppContext);
	const navigate = useNavigate();
	const { isWhitelabel, schoolCode: whitelabelCode } = useWhitelabel();
	const { school_code: urlCode } = useParams();
	const school_code = whitelabelCode || urlCode;

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [visible1, setVisible1] = useState(false);
	const [loading, setLoading] = useState(false);
	const [verifying, setVerifying] = useState(true);
	const [schoolLogo, setSchoolLogo] = useState(null);

	useEffect(() => {
		makeGetAPICall(
			"schools.php",
			{ action: "get_school_details", school_code },
			(response) => {
				setVerifying(false);
				if (!response.data) {
					navigate("/login", { replace: true });
				} else {
					setSchoolLogo(response.data.logo);
					setToStorage("school_code", school_code);
				}
			},
			() => {
				setVerifying(false);
				navigate("/login", { replace: true });
			}
		);
	}, [school_code, navigate]);

	const handleSubmit = (event) => {
		event.preventDefault();
		setLoading(true);
		makePostAPICall(
			"students.php",
			{ action: "signin", email, password, school_code },
			(response) => {
				setToken(response.data.token);
				setUser(response.data.student);
				setSchool(response.data.school);

				setToStorage("studentToken", response.data.token);
				setToStorage("studentUser", encryptData(response.data.student));
				setToStorage("school", encryptData(response.data.school));

				navigate("/home");
			},
			(response) => {
				Swal.fire({
					position: "top-end",
					title: response.msg,
					showConfirmButton: false,
					timer: 1500,
				}).then(() => setLoading(false));
			}
		);
	};

	if (token && user) {
		return <Navigate to="/home" replace />;
	}

	if (verifying) {
		return (
			<div>
				<LogoContainer className="container">
					<div className="d-flex justify-content-center justify-content-sm-start">
						<Logo src={logo} alt="Examcentre Logo" />
					</div>
				</LogoContainer>
				<Loader />
			</div>
		);
	}

	return (
		<div>
			<LogoContainer className="container">
				<div className="d-flex justify-content-center justify-content-sm-start">
					<Logo src={logo} alt="Examcentre Logo" />
				</div>
			</LogoContainer>
			<div className="row"></div>
			<div className="col-lg-12 col-xl-12 col-md-12 mx-auto px-5">
				<div className="d-flex justify-content-center flex-column align-items-center">
					{schoolLogo && <SchoolLogo src={schoolLogo} alt="School Logo" />}
					<Header>Sign into Your Account</Header>

					<FormContainer onSubmit={(e) => handleSubmit(e)}>
						<FormGroup>
							<FormText>Email</FormText>
							<input
								className="login-input"
								type="email"
								name="email"
								placeholder="Email Address"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
							/>
						</FormGroup>
						<FormGroup>
							<FormText>Password</FormText>
							<div className="has-pwd-icon">
								<input
									type={visible1 ? "text" : "password"}
									name="password"
									placeholder="Password"
									className="login-input"
									value={password}
									onChange={(e) => setPassword(e.target.value)}
									required
								/>
								{visible1 ? (
									<BsEye className="view-pwd" size={20} onClick={() => setVisible1((prevState) => !prevState)} />
								) : (
									<BsEyeSlash className="view-pwd" size={20} onClick={() => setVisible1((prevState) => !prevState)} />
								)}
							</div>
						</FormGroup>
						<Button type="submit" disabled={loading}>{loading ? <span className="btn-loader"></span> : "Login"}</Button>
						{!isWhitelabel && (
							<SwitchButton type="button" onClick={() => { localStorage.removeItem("school_code"); navigate("/login"); }}>
								Switch School
							</SwitchButton>
						)}
					</FormContainer>
				</div>
			</div>
		</div>
	);
}
const LogoContainer = styled.div`
	padding: 50px;
`;

const Logo = styled.img`
	width: 150px;
	object-fit: contain;
`;
const SwitchButton = styled.button`
	margin-top: 10px;
	margin-left: auto;
	font-weight: 500;
	font-size: 14px;
	color: ${(props) => props.theme.primary};
	background: none;
	border: none;
	cursor: pointer;
	display: block;
	width: 100%;
	text-align: center;
`;

const SchoolLogo = styled.img`
	width: 120px;
	height: 120px;
	object-fit: contain;
	border-radius: 50%;
	margin-bottom: 20px;
`;

const Header = styled.h1`
	font-family: Inter;
	font-style: normal;
	font-weight: bold;
	font-size: 3.6rem;
	line-height: 43px;
	text-align: center;
	color: ${(props) => props.theme.primary};
`;
const FormContainer = styled.form`
	width: 100%;
	max-width: 450px;
	margin: 50px 0 20px;
`;
const FormGroup = styled.div`
	margin-bottom: 20px;
	width: 100%;
	max-width: 450px;
`;
const Text = styled.p`
	font-family: Inter;
	font-style: normal;
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 24px;
	text-align: center;
	margin-bottom: 50px;
	color: ${(props) => props.theme.grey};
`;

const FormText = styled(Text)`
	text-align: left;
	margin-bottom: 5px;
	font-size: 16px;
	font-weight: 500;
	color: grey;
`;

const Button = styled.button`
	width: 100%;
	height: 48px;
	border-radius: 10px;
	background-color: ${(props) => props.theme.primary};
	color: #ffffff;
	border: none;
	font-family: Inter;
	font-style: normal;
	font-weight: bold;
	font-size: 1.6rem;
	line-height: 19px;
	margin-top: 30px;

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;

export default LoginWithCode;
